import React from "react";

type CardVisualProps = {
  assetId?: string;
};

export function CardVisual({ assetId }: CardVisualProps) {
  if (!assetId) {
    return null;
  }

  return (
    <figure className="card-visual" aria-hidden="true" data-card-asset={assetId}>
      <img
        src={`/assets/dynamicbooks-v3/${assetId}.svg`}
        alt=""
        width="720"
        height="460"
        loading="lazy"
        decoding="async"
      />
    </figure>
  );
}
